export enum DirectEditMode {
	Disabled = 0,
	CorporateOnly = 1
}